module.exports = __webpack_public_path__ + "media/images/assignment/preview-01dec77c090fa688f3b10497c77e395d.svg";